import { render, staticRenderFns } from "./App.vue?vue&type=template&id=a08f3238&scoped=true&"
import script from "./App.vue?vue&type=script&lang=ts&setup=true&"
export * from "./App.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./App.vue?vue&type=style&index=0&id=a08f3238&prod&scoped=true&lang=scss&"
import style1 from "./App.vue?vue&type=style&index=1&id=a08f3238&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a08f3238",
  null
  
)

export default component.exports